import { apiClient } from '../../../../api/axios';
import type { ApiResponse, Category } from '../common/types';
import type { CategoryAdminItem, CreateUpdateCategoryAdminPayload, CategoryAdminResponse } from './types';

export const categoryAdminService = {
    getAllCategoryAdmins: async (): Promise<ApiResponse<CategoryAdminItem[]>> => {
        const response = await apiClient.get('/CategoryAdministrators/GetCategoryAdministrator');
        return response.data;
    },

    getCategoriesForCategoryAdmin: async (): Promise<ApiResponse<Category[]>> => {
        const response = await apiClient.get('/Category/GetCategoryForCategoryAdmin');
        return response.data;
    },

    createUpdateCategoryAdmin: async (payload: CreateUpdateCategoryAdminPayload): Promise<ApiResponse<CategoryAdminResponse>> => {
        const response = await apiClient.post('/CategoryAdministrators/CreateUpdateAdminCategory', payload);
        return response.data;
    },

    deleteCategoryAdmin: async (id: number): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(`/CategoryAdministrators/DeleteCategoryAdministratorRecord?Id=${id}`);
        return response.data;
    },
};
